// extracted by mini-css-extract-plugin
export default {"button":"button_button__zpxkc","secondary":"button_secondary__B668O","disabled":"button_disabled__RVTMj","green":"button_green__a5VEa","outlined":"button_outlined__v8BGE"};